// extracted by mini-css-extract-plugin
export default {"title":"Main_title__JlDQ5","introContainer":"Main_introContainer__0a3U5","introContent":"Main_introContent__eCmq4","introImg":"Main_introImg__mNy8d"};